import React from "react";
import { useCampaignEmailTemplateQuery } from "__generated__/graphqlUnauthenticated";
import { State } from "common/state/State";
import { Box } from "@mui/material";
import { getProcessedTemplateHtml } from "./getProcessedTemplateHtml";
import { useTranslation } from "react-i18next";

interface ICampaignEmailTemplateProps {
  campaignUid: string;
  emsUserToken: string;
}

export const CampaignEmailTemplate: React.FC<ICampaignEmailTemplateProps> = ({
  campaignUid,
  emsUserToken,
}) => {
  const { t: translate } = useTranslation("email_marketing");
  const { data, loading, error } = useCampaignEmailTemplateQuery({
    variables: {
      uid: campaignUid,
      emsUserToken,
    },
  });
  const processedTemplateHtml =
    (data?.emailMarketingCampaign?.templateHtml &&
      getProcessedTemplateHtml(
        data.emailMarketingCampaign.templateHtml,
        data?.emailMarketingCampaignRecipientVariables?.entries || [],
      )) ||
    "";

  return (
    <State
      loading={loading}
      error={!!error}
      empty={!loading && !data?.emailMarketingCampaign}
    >
      <Box
        sx={{
          minHeight: "100vh",
          overflow: "scroll",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <iframe
          srcDoc={processedTemplateHtml}
          title={translate("campaign.email_template.title")}
          data-cy="campaign-email-iframe"
          style={{
            width: "100%",
            backgroundColor: "white",
            maxWidth: 680,
            border: 0,
          }}
        >
          <p>{translate("campaign.email_template.iframe_not_supported")}</p>
        </iframe>
      </Box>
    </State>
  );
};
